import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'

const styles = theme => ({
  Label: {
    cursor: 'pointer',
    transition: 'linear 100ms color',
    '&:hover': {
      color: theme.palette.primary.light,
    },
  },
})

const Link = ({ classes, children, onClick }) => (
  <Typography
    variant={'body2'}
    color={'primary'}
    onClick={onClick}
    className={classes.Label}
  >
    {children}
  </Typography>
)

Link.propTypes = {
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default withStyles(styles, { withTheme: true })(Link)



// WEBPACK FOOTER //
// ./src/sections/flow/components/link.jsx